import type { ITagRelations } from '@dakedake/types'
import { useCallback, useState } from 'react'
import { tagRelationsList } from '@/services'

export default function useTagRelations() {
  const [data, setData] = useState<ITagRelations[]>([])

  const getTagRelationsList = useCallback(async (params: { sid?: number, aid?: number }) => {
    const res = await tagRelationsList(params)
    setData(res.data)
  }, [])

  return {
    tagRelations: data,
    getTagRelationsList
  }
}
